import React, { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useTranslation } from 'react-i18next';
import { formationPositions, matchPlayerName, matchValue } from '../../utils/matchRecord';

export default function MatchLineupPitch({ acta, partido, onPlayer }) {
  const { t } = useTranslation('matches');
  const mobile = useMediaQuery('(max-width:1100px)');
  const [selected, setSelected] = useState('home');
  const teams = [
    { key: 'home', name: partido.equipoLocal, system: acta.sistemaLocal, players: acta.jugadoresLocales, away: false },
    { key: 'away', name: partido.equipoVisitante, system: acta.sistemaVisitante, players: acta.jugadoresVisitantes, away: true },
  ].map(team => ({ ...team, positions: formationPositions(team.players, team.system, team.away) }));
  if (!teams.some(team => team.positions)) return null;
  return <section className="mr-panel mr-lineup" aria-label={t('record.formation')}>
    <header className="mr-section-heading"><div><span className="mr-eyebrow">{t('record.startingEleven')}</span>
      <h2>{t('record.formation')}</h2><p>{t('record.formationHelp')}</p></div></header>
    <div className="mr-formation-systems">{teams.map(team => <div key={team.key}>
      <span>{team.name}</span><strong>{matchValue(team.system)}</strong></div>)}</div>
    {mobile && <div className="mr-segmented" role="group" aria-label={t('record.pitchTeam')}>
      {teams.map(team => <button key={team.key} type="button" aria-pressed={selected === team.key}
        onClick={() => setSelected(team.key)}>{team.name}</button>)}</div>}
    <div className={`mr-pitch${mobile ? ' mr-pitch-mobile' : ''}`} role="group" aria-label={t('record.formation')}>
      <div className="mr-pitch-lines" aria-hidden="true"><i className="mr-centre-line" /><i className="mr-centre-circle" />
        <i className="mr-area mr-area-home" /><i className="mr-area mr-area-away" /></div>
      {teams.filter(team => !mobile || team.key === selected).map(team => team.positions
        ? <div key={team.key} role="group" aria-label={`${team.name} · ${team.system}`}>
          {team.positions.map(({ player, x, y, line }, index) => {
            const name = matchPlayerName(player.nombre);
            const horizontal = mobile ? 100 - y : x;
            const vertical = mobile ? 100 - (team.away ? 100 - x : x) * 2 : y;
            return <button type="button" className={`mr-pitch-player mr-side-${team.key}`} key={player.codJugador || player.id || index}
              style={{ left: `${horizontal}%`, top: `${vertical}%` }} data-line={line} data-order={index + 1}
              title={name} aria-label={`${matchValue(player.numero)} · ${name}`}
              onClick={() => player.codJugador && onPlayer(player.codJugador)}>
              <span className="mr-player-photo"><PersonOutlineIcon aria-hidden="true" />
                {player.foto && <img src={player.foto} alt="" loading="lazy" onError={event => { event.currentTarget.hidden = true; }} />}</span>
              <span className="mr-pitch-player-name"><b>{matchValue(player.numero)}</b> {name}</span>
              {player.valoracion !== null && player.valoracion !== undefined && player.valoracion !== ''
                && <span className="mr-player-rating">{matchValue(player.valoracion)}</span>}
            </button>;
          })}
        </div>
        : <p className={`mr-pitch-unavailable mr-side-${team.key}`} key={team.key}>{team.name}<span>{t('record.formationUnavailable')}</span></p>)}
    </div>
    <p className="mr-help">{t('record.pitchNote')}</p>
  </section>;
}
